interface StepConfigHeaderProps {
  title: string;
  isEnabled: boolean;
  onToggleEnabled: (enabled: boolean) => void;
  isSystemDefault?: boolean;
  disabled?: boolean;
  hideToggle?: boolean;
}

export function StepConfigHeader({
  title,
  isEnabled,
  onToggleEnabled,
  disabled = false,
  hideToggle = false,
}: StepConfigHeaderProps) {
  return (
    <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-4 py-3">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          {!hideToggle && (
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={isEnabled}
                onChange={(event) => onToggleEnabled(event.target.checked)}
                disabled={disabled}
                className="sr-only peer"
                aria-label={`Toggle ${title}`}
              />
              <div className="w-11 h-6 rounded-full bg-gray-300 dark:bg-gray-600 transition-colors peer-checked:bg-primary-700 peer-focus-visible:ring-2 peer-focus-visible:ring-primary-400 peer-disabled:opacity-50 peer-disabled:cursor-not-allowed after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:h-5 after:w-5 after:rounded-full after:bg-white after:transition-transform peer-checked:after:translate-x-5" />
            </label>
          )}
          <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100 truncate">
            {title}
          </h3>
        </div>
      </div>
    </div>
  );
}
